import { FC, useContext, useState } from "react";

import { useGetURLQuery } from "capitalrx-components-2.0";

import { useGetPharmacyQuery } from "@/api/getPharmacy";
import { QueryParams } from "@/types/QueryParams";
import { ThemeSelectorContext } from "@/context/index";

import FindBestPriceResultsLayout from "@/layout/FindBestPriceResults";
import { WhiteLabelResultsLayout } from "@/layout/WhiteLabel";
import PharmacyDetails from "@/components/PharmacyDetails/PharmacyDetails";
import FindBestPriceMap from "@/components/FindBestPriceMap";

import styles from "./PharmacyDetails.module.scss";

const PharmacyDetailsPage: FC = () => {
  const { client } = useContext(ThemeSelectorContext);
  const [toggleMapViewMobile, setToggleMapViewMobile] = useState<boolean>(false);
  const queryParams = useGetURLQuery<QueryParams>(null);

  const { data, isLoading, isFetching, isSuccess, isError } = useGetPharmacyQuery({ provider_id: queryParams.providerId });

  const onToggleMapViewButtonClick = (): void => {
    setToggleMapViewMobile(!toggleMapViewMobile);
  };

  const defaultMapCoordinates = {
    lat: parseInt(data?.latitude),
    lng: parseInt(data?.longitude),
  };

  const distance = parseInt(queryParams.distance);
  const pharmacyData = data;

  const pharmacyList = { distance: distance, pharmacy: pharmacyData };

  const pharmacyArray = [pharmacyList];

  const successComponent = (
    <>
      <header className={styles.HideFromDisplay}>Find Best Price Pharmacy Details</header>
      <PharmacyDetails pharmacyInfo={data} pharmacyParams={queryParams} isLoading={isLoading || isFetching}></PharmacyDetails>
      <FindBestPriceMap
        pharmacyResults={pharmacyArray}
        defaultMapCoordinates={defaultMapCoordinates}
        isLoading={isLoading}
        isFetching={isFetching}
        mapView={toggleMapViewMobile}
        toggleMapView={onToggleMapViewButtonClick}
        allowRedoSearch={false}
        showInfoWindowButton={false}
      />
    </>
  );

  return (
    <>
      {client && (
        <WhiteLabelResultsLayout>
          {isSuccess && <>{ successComponent }</>}
        </WhiteLabelResultsLayout>
      )}
      {!client && (
        <FindBestPriceResultsLayout showError={isError}>
          {isSuccess && <>{ successComponent }</>}
        </FindBestPriceResultsLayout>
      )}
    </>

  );
};

export default PharmacyDetailsPage;
